<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer v-if="!isHomePage" />
    <div class="seekadvicefrom" @click="askabout">
      <img
        src="https://lidajianan-1312661431.cos.ap-guangzhou.myqcloud.com/蓝头.png"
        alt=""
      />
      <div class="askabout">免费咨询</div>
    </div>
    <div class="modalss" v-show="isOpen">
      <div class="modal-content">
        <span class="close" @click="isOpen = false">&times;</span>
        <h2>请通过以下方式进行咨询</h2>
        <p style="padding-top: 10px;padding-left: 6px;">电话：0755-27822259</p>
        <p style="padding-left: 6px;">手机：18603072366</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isOpen: false,
      isHomePage: false
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.isHomePage = to.path === '/' || to.path === '/home';
      },
      immediate: true
    }
  },
  methods: {
    askabout() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
  overflow-x: hidden;
}

#app {
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
  position: relative;
}

/* 针对固定导航栏的全局内容偏移处理 */
/* 首页使用全屏滚动插件，内部各 Section 已单独处理 padding-top */
#app > .homepage-container {
  padding-top: 0 !important;
}

/* 其他内页增加顶部间距，确保内容不被 80px 高度的固定导航栏遮挡 */
#app > div:not(.homepage-container):not(.switch):not(.seekadvicefrom):not(.modalss):not(#header) {
  padding-top: 80px;
}

/* 移动端适配：如果移动端导航高度不同，可以在此处调整 */
@media (max-width: 768px) {
  #app > div:not(.homepage-container):not(.switch):not(.seekadvicefrom):not(.modalss):not(#header) {
    padding-top: 70px; /* 移动端 header 稍矮 */
  }
}

.switch {
  position: fixed;
  bottom: 120px;
  right: 20px;
  z-index: 99;
  cursor: pointer;
}

.switch img {
  width: 50px;
  transition: all 0.3s;
}

.switch:hover img {
  transform: scale(1.1);
}

.seekadvicefrom {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 99;
  cursor: pointer;
  background: #1577c2;
  color: #fff;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(21, 119, 194, 0.3);
}

.seekadvicefrom img {
  width: 24px;
}

.modalss {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 50px;
  border-radius: 10px;
  width: 400px;
  text-align: center;
  position: relative;
}

.close {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue